/**
 * @constant epstSteps
 * @description
 * Define los pasos/secciones que conforman la certificación EPST (English Proficiency Standard Test).
 * Cada paso representa una sección del examen, un descanso (BREAK), o la pantalla de bienvenida/finalización.
 *
 * Esta estructura se utiliza para construir el flujo del examen en componentes tipo wizard o formularios paso a paso.
 *
 * @type {Array<Object>}
 * @property {string} icon - Icono representativo de la sección.
 * @property {string} label - Nombre visible de la sección en la interfaz.
 * @property {string} sectionDesc - Descripción interna de la sección.
 */
export const epstSteps = [
	{
		icon: 'book-open',
		label: 'Welcome',
		sectionDesc: 'Welcome'
	},
	{
		icon: 'book-open',
		label: 'Grammar',
		sectionDesc: 'Grammar'
	},
	{
		icon: 'clock',
		label: 'BREAK',
		sectionDesc: 'BREAK'
	},
	{
		icon: 'book-open',
		label: 'Reading',
		sectionDesc: 'Reading'
	},
	{
		icon: 'clock',
		label: 'BREAK',
		sectionDesc: 'BREAK'
	},
	{
		icon: 'book-open',
		label: 'Listening',
		sectionDesc: 'Listening'
	},
	{
		icon: 'clock',
		label: 'BREAK',
		sectionDesc: 'BREAK'
	},
	{
		icon: 'book-open',
		label: 'Writing',
		sectionDesc: 'Writing'
	},
	{
		icon: 'clock',
		label: 'BREAK',
		sectionDesc: 'BREAK'
	},
	{
		icon: 'book-open',
		label: 'Speaking',
		sectionDesc: 'Speaking'
	},
	{
		icon: 'thumbs-up',
		label: 'Done',
		sectionDesc: 'DONE'
	}
];